import { DeferredPage } from "@/components/data-display/deferred-page";

// Deferred (page-delivery-pipeline.md G6, 2026-09-23). No liquidity backend exists in this
// environment: the policy threshold check and reviewer name were previously fabricated.
// See context/page_pipeline/BOARD.md wave 4 and context/page_pipeline/BACKEND_GAPS.md.
export default function TreasuryLiquidityIntentPage() {
  return (
    <DeferredPage
      nav={{ kind: "breadcrumb", parents: [{ label: "Treasury", href: "/treasury" }, { label: "Liquidity Dashboard", href: "/treasury/liquidity" }], label: "Liquidity Intent Review" }}
      state={{
        title: "Liquidity intent review is not available in this environment yet",
        description: "Liquidity intent review, including policy threshold checks, requires the liquidity/approval backend, which does not exist in this environment yet.",
      }}
    />
  );
}
